<template>
  <v-col class="pa-0">
    <p class="area-description-text">
      {{ descriptionText }}
    </p>

    <ThemedTextField
      v-model="descriptionModel"
      label="Description"
      outlined
      persistent-placeholder
      class="mt-4"
      dense
    />
  </v-col>
</template>

<script>
import { mapState } from "vuex";
import ThemedTextField from "@/core/ThemedTextField.vue";
export default {
  name: "AreaDescriptionComponent",
  components: { ThemedTextField },
  data: function () {
    return {};
  },
  computed: {
    ...mapState("weatherRouting/createCustomAreaModule", ["areaDescription"]),
    descriptionModel: {
      get() {
        return this.areaDescription;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/createCustomAreaModule/SET_CUSTOM_AREA_DESCRIPTION",
          value,
          { root: true }
        );
      },
    },
    descriptionText() {
      return this.descriptionModel === "" ? "Untitled" : this.descriptionModel;
    },
  },
};
</script>

<style scoped>
.area-description-text {
  font-size: 16px;
  color: var(--color-text);
}
</style>
